export const OFFLINE_READING_FEATURE_FLAG = 'FTR_OFFLINE_READING';

export const OFFLINE_STORAGE_NAMESPACE = 'offline';
export const OFFLINE_LANGUAGE_STORAGE_KEY = [OFFLINE_STORAGE_NAMESPACE, 'lang'];

/** Background of the offline page hero. The service worker precaches it so it shows with no network. */
export const OFFLINE_HERO_IMAGE_URL = 'https://assets.bwbx.io/images/users/iqjWHBFdfxIU/iKQvZvAFSrB8/v3/-1x-1.webp';
